type OtpErrorTypes = {
    code: 400 | 404 | 410 | 429;
    type: 'INVALID_OTP' | 'NOT_FOUND' | 'EXPIRED' | 'INVALID_OTP' | 'TOO_MANY_ATTEMPTS';
    message: string;
};

export class OtpError extends Error {
    constructor(
        public code: OtpErrorTypes['code'],
        public type: OtpErrorTypes['type'],
        message: string,
    ) {
        super(message);
        this.name = 'OtpError';
    }
}

export type OtpApiResponse =
    | {
          success: true;
          data: {
              message: string;
          };
      }
    | {
          success: false;
          errors: {
              message: string;
              path?: string[];
          }[];
      };

export type OtpIntentPayload =
    | {
          email: string;
          phone?: never;
          device: { id: string };
          session: { id: string };
          campaign: { id: string };
          campaignVersion: { id: string };
      }
    | {
          phone: string;
          email?: never;
          device: { id: string };
          session: { id: string };
          campaign: { id: string };
          campaignVersion: { id: string };
      };

export type OtpIntentResult = {
    success: boolean;
    data: {
        verificationIntent: {
            id: string;
        };
    };
    errors?: {
        field: string;
        message: string;
    }[];
};

export type OtpVerifyPayload = {
    otp: string;
    verificationIntentId: string;
};

export type OtpVerificationStatus = 'success' | 'error';

export type OtpVerifyResult = {
    success: boolean;
    data: {
        message: string;
    };
    errors?: {
        field: string;
        message: string;
    }[];
};

export type OtpVerificationCapabilitiesResult = {
    success: boolean;
    data: {
        phone: boolean;
        email: boolean;
    };
};
